import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEntityAcess } from "../settings/users/invite-modal/InviteModalSlice";
import { fetchUserDetails } from "~/Pages/Login/loginSlice";

function useCompleteProfile() {
  const [selectTimeZone, setSelectTimeZone] = useState(false);
  const [timezone, setTimeZone] = useState(null);
  const [isUpateTimezone, setIsUpateTimezone] = useState(false);
  const [hasTimeZone, setHasTimeZone] = useState(false);
  const user_id = useSelector((state) => state.login.id || null);
  const userTimeZone = useSelector((state) => state.login.timezone);

  useEffect(() => {
    if (userTimeZone === null) {
      setHasTimeZone(true);
    } else {
      setHasTimeZone(false);
    }
  }, [userTimeZone]);

  const dispatch = useDispatch();
  const handleSelectTimeZone = (value) => {
    setTimeZone(value);
  };
  const handleAddTimezone = () => {
    const payload = {
      id: user_id,
      timezone,
    };
    setIsUpateTimezone(true);
    dispatch(addEntityAcess(payload)).then(() => {
      dispatch(fetchUserDetails()).then(() => {
        setIsUpateTimezone(false);
      });
    });
  };
  return {
    selectTimeZone,
    setSelectTimeZone,
    handleAddTimezone,
    timezone,
    isUpateTimezone,
    setIsUpateTimezone,
    handleSelectTimeZone,
    hasTimeZone,
  };
}

export default useCompleteProfile;
